import { MaxWidthContainer } from 'components/MaxWidthContainer';
import { PageLayoutProps } from 'lib/shared/types/PageLayout';

export const MaxWidthContainerLayout = ({ children }: PageLayoutProps) => (
  <MaxWidthContainer my={20}>{children}</MaxWidthContainer>
);

export const getLayout = (page) => (
  <MaxWidthContainerLayout>{page}</MaxWidthContainerLayout>
);
